module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,16.25A1.25,1.25,0,1,1,13.25,17,1.25,1.25,0,0,1,12,18.25Zm1-4.38V15H11V12h1a2,2,0,1,0-2-2H8a4,4,0,1,1,5,3.87Z\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/question.svg
// module id = 812
// module chunks = 1